'use client';
import { type Product } from '@shopify/hydrogen-react/storefront-api-types';
import { createContext } from 'react';

export type ProductsContext = {
  products: Product[];
};

export const ProductsContext = createContext<ProductsContext | undefined>(
  undefined,
);
